import { forwardRef, type ComponentPropsWithoutRef } from 'react'
import clsx from 'clsx'
import { stack, type StackVariants } from './Stack.css'

type StackProps = {
  /** Additional CSS class names */
  className?: string
} & StackVariants &
  ComponentPropsWithoutRef<'div'>

/**
 * A flex layout container for stacking elements.
 *
 * @example
 * ```tsx
 * <Stack gap={16}>
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 * </Stack>
 *
 * <Stack direction="row" gap={8} align="center">
 *   <Button>Save</Button>
 *   <Button variant="ghost">Cancel</Button>
 * </Stack>
 * ```
 */
export const Stack = forwardRef<HTMLDivElement, StackProps>(
  ({ direction, align, justify, wrap, gap, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={clsx(stack({ direction, align, justify, wrap, gap }), className)}
        {...props}
      />
    )
  }
)

Stack.displayName = 'Stack'
